import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '../views/StudentLogin/Login.vue'


import WebsiteLayout from '../views/SactinWebsite/WebsiteLayout/WebsiteLayout.vue';
import WebsiteHome from '../views/SactinWebsite/WebsitePages/WebsiteHome.vue';


import WebsiteFooter from '../views/SactinWebsite/WebsitePages/WebsiteFooter.vue';



import AboutUS from '../views/SactinWebsite/WebsitePages/AboutUS.vue';
import OurServices from '../views/SactinWebsite/WebsitePages/OurServices.vue';
import ContactUS from '../views/SactinWebsite/WebsitePages/ContactUS.vue';
import SactinERP from '../views/SactinWebsite/WebsitePages/SactinERP.vue';
import SactinGPS from '../views/SactinWebsite/WebsitePages/SactinGPS.vue';
import SactinFaceAttentance from '../views/SactinWebsite/WebsitePages/SactinFaceAttentance.vue';
import SactinRealTimeTracking from '../views/SactinWebsite/WebsitePages/SactinRealTimeTracking.vue';
import SactinLibrary from '../views/SactinWebsite/WebsitePages/SactinLibrary.vue';
import SactinAdministrative from '../views/SactinWebsite/WebsitePages/SactinAdministrative.vue';
import SactinInteractivePanel from '../views/SactinWebsite/WebsitePages/SactinInteractivePanel.vue';
import PanelInch65 from '../views/SactinWebsite/WebsitePages/PanelInch65.vue';
import PanelInch75 from '../views/SactinWebsite/WebsitePages/PanelInch75.vue';
import PanelInch85 from '../views/SactinWebsite/WebsitePages/PanelInch85.vue';
import PanelInch98 from '../views/SactinWebsite/WebsitePages/PanelInch98.vue';
import privacypolicysactin from '../views/SactinWebsite/WebsitePages/privacypolicysactin.vue';






Vue.use(VueRouter)

const routes = [


  // start oct1
  {
    path: '/',
    name: "WebsiteLayout",
    component: WebsiteLayout,
    redirect: '/home',
    props: true,


    children: [
      {
        path: '/home',
        name: "WebsiteHome",
        component: WebsiteHome,
        props: true,
      },
     
      {
        path: '/websitfooter',
        name: " WebsiteFooter",
        component:  WebsiteFooter,
        props: true,
      },
      

        {
        path: '/aboutus',
        name: "aboutus",
        component: AboutUS,
        props: true,
      },
        {
        path: '/ourservices',
        name: "ourservices",
        component:OurServices,
        props: true,
      },
       {
        path: '/contactus',
        name: "contactus",
        component:ContactUS,
        props: true,
      },
         {
        path: '/sactin-erp',
        name: "sactin-erp",
        component:SactinERP,
        props: true,
      },
      
         {
        path: '/sactin-gps-tracking',
        name: "sactin-gps-tracking",
        component: SactinGPS ,
        props: true,
      },
         {
        path: '/sactin-face-attentance-system',
        name: "sactin-face-attentance-system",
        component: SactinFaceAttentance ,
        props: true,
      },
          {
        path: '/sactin-real-time-tracking-system',
        name: "sactin-real-time-tracking-system",
        component: SactinRealTimeTracking ,
        props: true,
      },
     
           {
        path: '/sactin-library-system',
        name: "sactin-library-system",
        component:  SactinLibrary ,
        props: true,
      },
              {
        path: '/sactin-office-administrative-system-management',
        name: "sactin-office-administrative-system-management",
        component: SactinAdministrative ,
        props: true,
      },
      {
        path: '/sactin-interactive-panel',
        name: "sactin-interactive-panel",
        component:  SactinInteractivePanel ,
        props: true,
      },
       {
        path: '/65-inch-sactin-interactive-panel',
        name: "65-inch-sactin-interactive-panel",
        component:  PanelInch65 ,
        props: true,
      },
       {
        path: '/75-inch-sactin-interactive-panel',
        name: "75-inch-sactin-interactive-panel",
        component:  PanelInch75 ,
        props: true,
      },
       {
        path: '/85-inch-sactin-interactive-panel',
        name: "85-inch-sactin-interactive-panel",
        component:  PanelInch85 ,
        props: true,
      },
       {
        path: '/98-inch-sactin-interactive-panel',
        name: "98-inch-sactin-interactive-panel",
        component:  PanelInch98 ,
        props: true,
      },
       {
        path: '/privacy-policy-sactin',
        name: "privacy-policy-sactin",
        component:  privacypolicysactin ,
        props: true,
      },
              
    
    ]
  },
  // end oct 1



]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router


